import { Link } from 'react-router-dom'
import { Loader2, Lock, PowerOff, SearchX } from 'lucide-react'

// Pantallas de estado. Están juntas porque son variaciones de lo mismo y
// tenerlas en un archivo evita seis archivos de doce líneas.
export const Pantalla = {
  Cargando() {
    return (
      <div className="grid min-h-screen place-items-center bg-crema">
        <div className="flex flex-col items-center gap-3">
          <Loader2 className="h-6 w-6 animate-spin text-verde" />
          <p className="text-[14px] text-tinta-tenue">Cargando…</p>
        </div>
      </div>
    )
  },

  NoEncontrada() {
    return (
      <div className="grid min-h-[60vh] place-items-center px-6">
        <div className="max-w-[380px] text-center">
          <SearchX className="mx-auto mb-4 h-9 w-9 text-tinta-tenue" />
          <h1 className="text-[20px] font-bold text-tinta">No encontramos esta pantalla</h1>
          <p className="mt-2 text-[14px] text-tinta-tenue">
            Puede que el enlace esté viejo o que no tengas permiso para verla.
          </p>
          <Link to=".." relative="path" className="btn-secundario mt-5 inline-flex">
            Volver
          </Link>
        </div>
      </div>
    )
  },

  /**
   * Falta el permiso.
   *
   * Se distingue de NoEncontrada a propósito: decir "no existe" cuando en
   * realidad falta permiso hace que el usuario reporte un error que no es, y
   * el dueño del local no entienda por qué su empleado no ve la pantalla.
   */
  SinPermiso() {
    return (
      <div className="grid min-h-[50vh] place-items-center px-6">
        <div className="max-w-[380px] text-center">
          <Lock className="mx-auto mb-4 h-9 w-9 text-tinta-tenue" />
          <h1 className="text-[20px] font-bold text-tinta">No tenés permiso para esta pantalla</h1>
          <p className="mt-2 text-[14px] text-tinta-tenue">
            Pedile a quien administra el local que te habilite el permiso.
          </p>
        </div>
      </div>
    )
  },

  /**
   * El local apagó este módulo.
   *
   * Es una tercera cosa y no un «no existe» ni un «no tenés permiso», por el
   * mismo motivo por el que esas dos están separadas: quien llega acá por un
   * favorito o por un enlace viejo tiene que poder entender qué pasó y dónde
   * se arregla, y «no encontramos esta pantalla» lo manda a reportar un error
   * que no existe.
   */
  ModuloApagado({ nombre }: { nombre: string }) {
    return (
      <div className="grid min-h-[50vh] place-items-center px-6">
        <div className="max-w-[420px] text-center">
          <PowerOff className="mx-auto mb-4 h-9 w-9 text-tinta-tenue" />
          <h1 className="text-[20px] font-bold text-tinta">Este local no usa {nombre}</h1>
          <p className="mt-2 text-[14px] leading-relaxed text-tinta-tenue">
            El módulo está apagado, así que la pantalla no está disponible. Se prende en{' '}
            <strong>Configuración → Parámetros → Módulos</strong>, y lo que ya tengas cargado
            sigue estando: apagarlo no borra nada.
          </p>
        </div>
      </div>
    )
  },

  /** Estado vacío de un listado. */
  Vacia({
    titulo,
    detalle,
    accion,
    icono,
  }: {
    titulo: string
    detalle?: string
    accion?: React.ReactNode
    icono?: React.ReactNode
  }) {
    return (
      <div className="grid place-items-center px-6 py-16">
        <div className="max-w-[380px] text-center">
          {icono && <div className="mx-auto mb-4 text-tinta-tenue">{icono}</div>}
          <h2 className="text-[17px] font-semibold text-tinta">{titulo}</h2>
          {detalle && <p className="mt-1.5 text-[14px] leading-snug text-tinta-tenue">{detalle}</p>}
          {accion && <div className="mt-5">{accion}</div>}
        </div>
      </div>
    )
  },
}
